import React from "react";

interface RequiredFlagProps {
    required?: boolean;
}

export const RequiredFlag = (props: RequiredFlagProps) => {
    if (!props.required) {
        return null;
    }
    
    return (
        <div className="text-center justify-start text-status-danger text-base font-medium">*</div>
    );
}